import { render, staticRenderFns } from "./AbrirFichaPublica.vue?vue&type=template&id=39f2ee4b&scoped=true"
import script from "./AbrirFichaPublica.vue?vue&type=script&lang=js"
export * from "./AbrirFichaPublica.vue?vue&type=script&lang=js"
import style0 from "./AbrirFichaPublica.vue?vue&type=style&index=0&id=39f2ee4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f2ee4b",
  null
  
)

export default component.exports